/* eslint-disable react/jsx-indent */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useMemo, useState} from 'react';
import moment from 'moment';
import {connect, useDispatch} from 'react-redux';
import {Link, useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import {
  copyGrey,
  corruptedFile,
  edit,
  link,
  trashRed,
} from '../../assets/images/images';
import {
  EmptyState,
  PageLimit,
  Pagination,
  PrimaryButton,
  SearchInput,
  SecondaryButton,
  TableLayout,
} from '../../components';
import DashboardLayout from '../../components/DashboardLayout';
import {Constants, parseUrlParams} from '../../helpers';
import * as Actions from '../../store/actions';
import Loader from '../../components/Loader';
import {DEFAULT_PAGES} from './defaultPages';
import {EasyOnboardTour} from '../../components/Tour';
import {
  PageContext,
  TourContext,
  EasyOnboardContext,
} from '../../helpers/context';
import {
  formatNumberToCurrency,
  formatUsd,
} from '../../helpers/formatNumberToCurrency';
import {getCookieValue} from '../../helpers/getCookie';
import Dropdown from '../../components/TeamsDropdown';
import {Menu} from '@headlessui/react';
import DeleteFlowModal from './ConfirmFlowDelete';
import {useQuery} from 'react-query';
import {fetchAllWidgets} from '../../requests/queries/widgets';
import {useOnboardFlowApps} from '../../hooks/useApps';
import FilterV2 from 'components/FilterV2';
import PageNumber from 'components/PageNumber';
import {getLighterShade} from './colorUtils';

const statusFilter = {
  key: 'status',
  label: 'Status',
  type: 'select',
  options: [
    {label: 'Draft', value: 'draft'},
    {label: 'Published', value: 'published'},
    {label: 'Unpublished', value: 'unpublished'},
  ],
};

function EasyOnboard({
  widgets: {defaultWigetsPages, w_loading, singleWidget},
  auth: {userDetails, userSettings},
  getWidgetPricing,
  getWidget,
  setWidgetDefaultPages,
  setFraudDefaultPages,
  clearWidgetPages,
  setFraudRules,
  setSingleWidget,
  setWidgetPages,
}) {
  const navigate = useNavigate();
  const {setQuestions, setWidgetData} = useContext(EasyOnboardContext);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [deleteModal, setDeleteModal] = useState(false);
  const [widgetId, setWidgetId] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const {setPageName} = useContext(PageContext);
  const [selectedApp, setSelectedApp] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [filterParams, setFilterParams] = useState({
    status: undefined,
    dateRange: undefined,
  });

  useEffect(() => {
    setPageName('easyonboard');
  }, [setPageName]);

  const envData = getCookieValue('env');

  const {userApps, isLoading: appLoading} = useOnboardFlowApps();

  useEffect(() => {
    if (userApps.length > 0 && !selectedApp?.value) {
      setSelectedApp(userApps[0]);
    }
  }, [userApps, selectedApp]);

  const renderAppSkeletons = () => (
    <>
      {Array(5)
        .fill(0)
        .map((_, index) => (
          <div key={index} className="p-2 rounded-md gap-1">
            <div className="w-full h-[40px] rounded-md bg-[#e3e3e3] animate-pulse" />
          </div>
        ))}
    </>
  );

  const pageClick = selected => {
    setCurrentPage(selected);
  };

  const apiParams = parseUrlParams();
  apiParams.company_id = userDetails?.company?.id;
  apiParams.app_ids = selectedApp?.value;
  apiParams.limit = limit;

  const params = {
    ...apiParams,
    page: currentPage,
    // type: 'auth',
    limit,
    status: filterParams.status,
    ...(searchValue && {name: searchValue}),
    ...(filterParams.dateRange && {
      start: filterParams.dateRange.start,
      end: filterParams.dateRange.end,
    }),
  };

  const {data: allWidgets, isLoading} = useQuery(
    ['all-widgets', {...params}],
    () => fetchAllWidgets({...params}, dispatch),
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    const pageParam = searchParams.get('page');
    if (pageParam) {
      setCurrentPage(parseInt(pageParam));
      apiParams.page = parseInt(pageParam);
    } else {
      apiParams.page = currentPage;
    }
    getWidgetPricing();
  }, [
    currentPage,
    getWidgetPricing,
    limit,
    userDetails?.company?.id,
    selectedApp.value,
  ]);

  const handleView = id => {
    setSingleWidget(null);
    setWidgetPages({});
    setQuestions([]);
    setWidgetDefaultPages([]);
    setWidgetData({name: ''});
    id && getWidget(id, navigate);
  };

  const UPDATE_DEFAULT_PAGES = useMemo(() => DEFAULT_PAGES, []);
  useEffect(() => {
    const basePage = defaultWigetsPages?.length
      ? defaultWigetsPages
      : UPDATE_DEFAULT_PAGES;
    setWidgetDefaultPages(basePage);
    setFraudRules([]);
    setFraudDefaultPages(null);
    !singleWidget?.widget?.pages && clearWidgetPages();
  }, [
    setWidgetDefaultPages,
    clearWidgetPages,
    singleWidget?.widget?.pages,
    UPDATE_DEFAULT_PAGES,
    defaultWigetsPages,
    setFraudDefaultPages,
    setFraudRules,
  ]);

  const copyText = text => {
    navigator.clipboard.writeText(text);
    toast.success('Link copied');
  };

  const {manageFlows: canManageFlows} =
    useMemo(
      () => userDetails?.permissions?.onboardPermissions,
      [userDetails],
    ) || {};

  const {tourState, updateTourState} = useContext(TourContext);
  const displayPrice = (condition, price) =>
    condition &&
    userDetails &&
    userDetails.company &&
    userDetails.company.currency === 'USD'
      ? formatUsd(price || 0)
      : formatNumberToCurrency(
          price || 0,
          userDetails && userDetails.company && userDetails.company.currency,
          userSettings &&
            userSettings.settings &&
            userSettings.settings.dollar_exchange_rate,
        );
  const hasWidgetUrl = !!localStorage.subdomain && !!userDetails?.widgetUrl;
  const customWidgetUrl = hasWidgetUrl
    ? userDetails?.widgetUrl
    : userDetails?.company?.widget_url;

  const toggleFilterVisibility = () => {
    setShowFilter(prevShowFilter => !prevShowFilter);
  };

  const handleFilterChange = values => {
    setFilterParams({
      status: values.status,
      dateRange: values.dateRange,
    });
    setCurrentPage(1);
  };

  const isFiltered =
    allWidgets?.widgets?.length === 0 &&
    !isLoading &&
    (searchValue || filterParams.status || filterParams.dateRange);

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">
          Verification Flows
        </p>
      }
    >
      {tourState?.easy_onboard_tour ? (
        <EasyOnboardTour
          updateTourState={updateTourState}
          DATA={allWidgets?.widgets}
          loading={isLoading}
        />
      ) : null}

      <DeleteFlowModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        flowId={widgetId}
      />

      <div className="flex items-center py-2 flex-wrap gap-3 justify-between mx-[-32px] px-8 border border-transparent border-b-[#E4E4E6]">
        <div className="flex items-center gap-2">
          <SearchInput
            onChange={value => {
              setSearchValue(value);
              setCurrentPage(1);
            }}
            defaultValue={searchValue}
            className="outline-white80"
          />
          <SecondaryButton
            buttonText="Filter"
            onClick={toggleFilterVisibility}
          />
        </div>

        <Link
          to={Constants.PAGES_URL.EASY_ONBOARD_CREATE_FLOW}
          className="hidden sm:block"
          onClick={() => {
            setSingleWidget(null);
            setWidgetPages({});
            setWidgetDefaultPages(defaultWigetsPages);
          }}
        >
          <PrimaryButton
            buttonText="Create a flow"
            xPadding="p-[35px]"
            disabled={!canManageFlows}
            style={{cursor: !canManageFlows && 'not-allowed'}}
            title={
              canManageFlows
                ? 'Create a flow'
                : 'You do not have permission to Create a flow'
            }
          />
        </Link>
        <Link
          to={Constants.PAGES_URL.EASY_ONBOARD_CREATE_FLOW}
          className="fixed bottom-0 left-0 right-0 z-10 px-4 py-2 overflow-x-hidden sm:hidden bg-white80"
          style={{boxShadow: '0px -1px 8px rgba(51, 52, 66, 0.25)'}}
          onClick={() => setSingleWidget(null)}
        >
          <PrimaryButton
            buttonText="Create a flow"
            xPadding="p-[35px]"
            className="w-full bottom-2"
            disabled={!canManageFlows}
            style={{cursor: !canManageFlows && 'not-allowed'}}
            title={
              canManageFlows
                ? 'Create a flow'
                : 'You do not have permission to Create a flow'
            }
          />
        </Link>
      </div>

      <div className={`filter-slide-container ${showFilter ? 'open' : ''}`}>
        <FilterV2
          filters={[statusFilter]}
          onFilterChange={handleFilterChange}
        />
      </div>

      <div className="flex items-start w-full mt-5">
        <div className="min-w-[183px]">
          <h2 className="text-small font-medium text-[#5C688E] py-5 h-[44px] flex items-center bg-white80 px-4 uppercase">
            App Name
          </h2>

          <div className="flex flex-col bg-white80 overflow-y-auto h-[calc(100vh-220px)] userApp">
            {appLoading
              ? renderAppSkeletons()
              : userApps.map((app, index) => {
                  const baseColor =
                    userDetails?.company?.color_code || '#3f7cdb';
                  const lighterShade = getLighterShade(baseColor, 90);

                  return (
                    <div
                      key={index}
                      className="py-1 px-2 h-[55px] flex items-center justify-center"
                    >
                      <div
                        className={`px-4 py-2 w-full rounded-md cursor-pointer ${
                          app.value === selectedApp?.value
                            ? 'text-brandBlue'
                            : ''
                        }`}
                        style={
                          app.value === selectedApp?.value
                            ? {backgroundColor: lighterShade}
                            : {}
                        }
                        onClick={() => setSelectedApp(app)}
                      >
                        <button className="text-[13px] font-medium text-start">
                          {app.label}
                        </button>
                      </div>
                    </div>
                  );
                })}
          </div>
        </div>

        <div className="w-full mb-6 ml-[0.5px]">
          {isLoading ? (
            <Loader height={50} />
          ) : (
            <>
              <TableLayout noOverflow className="w-full !mx-[0px]">
                <thead className="font-semibold uppercase">
                  <tr className="bg-white80">
                    <th className="pl-4 sm:pl-6 xl:pl-8 h-11 font-medium text-left text-small text-[#5C688E] whitespace-nowrap w-[24.9%]">
                      <div className="flex items-end gap-1">
                        <span>Flow Name</span>
                      </div>
                    </th>
                    <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap w-[18.8%]">
                      <div className="flex items-end gap-1">
                        <span>Status</span>
                      </div>
                    </th>
                    <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap w-[22.9%]">
                      <div className="flex items-end gap-1">
                        <span>date created</span>
                      </div>
                    </th>
                    <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap w-[20%]">
                      <div className="flex items-end gap-1">
                        <span>Cost</span>
                      </div>
                    </th>

                    <th className="w-[9.1%]"></th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td colSpan={8}>
                      {isFiltered ? (
                        <EmptyState
                          body="This search did not return any data, try using different values."
                          src={corruptedFile}
                          imageHeight={48}
                          imageWidth={48}
                          noBtn
                        />
                      ) : null}
                    </td>
                  </tr>
                </tbody>

                <tbody
                  className="text-sm bg-white"
                  style={{opacity: w_loading ? 0.4 : 1}}
                >
                  <>
                    {allWidgets &&
                      allWidgets?.widgets
                        ?.filter(flow => flow?.type !== 'auth')
                        ?.map((widget, i) => (
                          <tr
                            className="border-[0.5px] border-[#E4E3EC] border-x-transparent"
                            key={i}
                          >
                            <td
                              onClick={() => {
                                handleView(widget?._id);
                              }}
                              className="p-4 pl-4 sm:pl-6 xl:pl-8 text-sm text-body whitespace-nowrap w-[24.9%]"
                            >
                              {widget?.name || '-'}
                            </td>
                            <td
                              onClick={() => {
                                handleView(widget?._id);
                              }}
                              className="p-4 pl-0 text-sm text-body whitespace-nowrap w-[18.8%]"
                            >
                              <div
                                className={`px-2 py-1 pt-[7px] text-xs font-medium uppercase rounded-full  w-fit ${
                                  widget?.published
                                    ? 'text-success20 bg-success'
                                    : 'text-white bg-black'
                                }`}
                              >
                                {widget?.published ? 'Published' : 'Draft'}
                              </div>
                            </td>
                            <td
                              onClick={() => {
                                handleView(widget?._id);
                              }}
                              className="p-4 pl-0 text-sm text-body whitespace-nowrap w-[22.9%]"
                            >
                              {moment(widget?.createdAt).format(
                                'MMM DD, YYYY hh:mm A',
                              ) || '-'}
                            </td>
                            <td
                              onClick={() => {
                                handleView(widget?._id);
                              }}
                              className="p-4 pl-0 text-sm text-body whitespace-nowrap w-[20%]"
                            >
                              {envData === 'Production'
                                ? widget?.cost?.min === widget?.cost?.max
                                  ? `
                       
                             ${displayPrice(
                               widget?.cost?.max,
                               widget?.cost?.max / 100,
                             )}`
                                  : ` 
                              ${displayPrice(
                                widget?.cost?.min,
                                widget?.cost?.min / 100,
                              )} - 
                             ${displayPrice(
                               widget?.cost?.max,
                               widget?.cost?.max / 100,
                             )}`
                                : `${displayPrice(true, 0)}`}
                            </td>

                            <td>
                              <div className="flex justify-center w-[9.1%]">
                                <Dropdown>
                                  <Menu.Item>
                                    {() => (
                                      <button
                                        onClick={() => {
                                          handleView(widget?._id);
                                        }}
                                        className="z-40 flex items-center gap-4 w-full font-medium text-gray-500 text-tiny"
                                      >
                                        <img
                                          src={edit}
                                          alt=""
                                          width={14}
                                          height={14}
                                        />
                                        {!canManageFlows ? 'View' : 'Edit'}
                                      </button>
                                    )}
                                  </Menu.Item>
                                  {widget?.published && (
                                    <Menu.Item>
                                      {() => (
                                        <button
                                          onClick={() =>
                                            window.open(
                                              `${
                                                customWidgetUrl ??
                                                process.env
                                                  .REACT_APP_WIDGET_BASE_URL
                                              }?widget_id=${widget?._id}`,
                                              '_blank',
                                            )
                                          }
                                          className="z-40 flex items-center gap-4 w-full font-medium text-gray-500 text-tiny"
                                        >
                                          <img
                                            src={link}
                                            alt=""
                                            width={14}
                                            height={14}
                                          />
                                          Visit
                                        </button>
                                      )}
                                    </Menu.Item>
                                  )}
                                  <Menu.Item>
                                    {() => (
                                      <button
                                        onClick={() =>
                                          copyText(
                                            `${
                                              customWidgetUrl ??
                                              process.env
                                                .REACT_APP_WIDGET_BASE_URL
                                            }?widget_id=${widget?._id}`,
                                          )
                                        }
                                        className="z-40 flex items-center gap-4 w-full font-medium text-gray-500 text-tiny"
                                      >
                                        <img
                                          src={copyGrey}
                                          alt=""
                                          width={14}
                                          height={14}
                                        />
                                        Copy
                                      </button>
                                    )}
                                  </Menu.Item>
                                  <Menu.Item>
                                    {() => (
                                      <button
                                        onClick={() => {
                                          setDeleteModal(true);
                                          setWidgetId(widget?._id);
                                        }}
                                        className="z-40 flex  items-center gap-4 w-full font-medium text-danger text-tiny"
                                      >
                                        <img
                                          src={trashRed}
                                          alt=""
                                          width={14}
                                          height={14}
                                        />
                                        Delete
                                      </button>
                                    )}
                                  </Menu.Item>
                                </Dropdown>
                              </div>
                            </td>
                          </tr>
                        ))}
                  </>
                </tbody>
              </TableLayout>

              {!isLoading && allWidgets?.widgets?.length !== 0 && (
                <div className="flex flex-wrap items-center justify-between gap-4 sm:gap-0 bg-white80 mx-[0px] px-8 py-[18px] border-[0.5px] border-y-[#E4E3EC] border-transparent">
                  <PageNumber
                    currentPage={+currentPage}
                    limit={limit}
                    totalCount={allWidgets?.totalRecords}
                  />

                  <div className="flex items-center gap-5">
                    <PageLimit
                      onLimitChange={setLimit}
                      total={allWidgets && allWidgets?.totalRecords}
                      length={allWidgets?.widgets?.length}
                      limit={limit}
                    />

                    <Pagination
                      total={
                        allWidgets &&
                        Math.ceil(allWidgets?.totalRecords / limit)
                      }
                      current={+currentPage}
                      onPageChange={activePage => {
                        pageClick(activePage);
                        const searchParams = new URLSearchParams(
                          document.location.search,
                        );
                        searchParams.set('page', activePage);
                        const newSearchParams = searchParams.toString();
                        navigate(`?${newSearchParams}`);
                      }}
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}

export default connect(state => state, Actions)(EasyOnboard);
